/* ET: Step Builder — slots / tabbed modal / pricing / batched cart controller */
(function () {
  'use strict';

  // HTML-escape any merchant/product-derived string before injecting via innerHTML.
  function esc(s) {
    var d = document.createElement('div');
    d.textContent = (s == null ? '' : String(s));
    return d.innerHTML;
  }

  // Attribute-context escape: also encode the double-quote that esc() leaves intact.
  function escAttr(s) {
    return esc(s).replace(/"/g, '&quot;');
  }

  function fillTokens(str, map) {
    str = str || '';
    Object.keys(map).forEach(function (k) { str = str.split(k).join(map[k]); });
    return str;
  }

  function StepBuilder(root) {
    var configEl = document.getElementById('et-step-config-' + root.getAttribute('data-step-bundle'));
    if (!configEl) { return; }
    var config;
    try { config = JSON.parse(configEl.textContent); } catch (e) { return; }

    var steps = config.steps || [];
    if (!steps.length) { return; }

    var labels = config.labels || {};
    var currencySymbol = config.currencySymbol || '';
    var discountPct = parseFloat(config.discountPercentage) || 0;
    var discountRef = config.discountReference || 'price';

    function formatMoney(cents) {
      var f;
      try { f = Shopify.formatMoney(cents); } catch (e) { f = currencySymbol + (Number(cents) / 100).toFixed(2); }
      return f;
    }

    // ---------- DOM refs ----------
    var slotEls = Array.prototype.slice.call(root.querySelectorAll('[data-slot]'));
    var atcBtn = root.querySelector('[data-atc]');
    var savingsEl = root.querySelector('[data-savings]');
    var modal = root.querySelector('[data-modal]');
    var tabEls = Array.prototype.slice.call(root.querySelectorAll('[data-tab]'));
    var panelEls = Array.prototype.slice.call(root.querySelectorAll('[data-panel]'));
    var totalEl = root.querySelector('[data-total]');
    var doneBtn = root.querySelector('[data-done]');
    var progressEl = root.querySelector('[data-progress]');
    var beforeEl = root.querySelector('[data-before]');
    var savingsPctEl = root.querySelector('[data-savings-pct]');

    // ---------- State: one selection per step (or null) ----------
    // selection[i] = { productId, variantId, variantTitle, price, compareAt, image } | null
    var selection = steps.map(function () { return null; });
    var activeTab = 0;
    var busy = false;

    function stepProduct(stepIndex, productId) {
      var products = (steps[stepIndex] && steps[stepIndex].products) || [];
      for (var i = 0; i < products.length; i++) {
        if (String(products[i].id) === String(productId)) { return products[i]; }
      }
      return null;
    }

    // ---------- Slot rendering ----------
    function renderSlot(i) {
      var slotEl = slotEls[i];
      if (!slotEl) { return; }
      var emptyEl = slotEl.querySelector('[data-slot-empty]');
      var filledEl = slotEl.querySelector('[data-slot-filled]');
      var removeEl = slotEl.querySelector('[data-slot-remove]');
      var sel = selection[i];

      if (sel) {
        slotEl.classList.remove('et-step-builder__slot--empty');
        slotEl.classList.add('et-step-builder__slot--filled');
        if (emptyEl) { emptyEl.hidden = true; }
        if (filledEl) {
          var img = sel.image
            ? '<img class="et-step-builder__slot-img" src="' + escAttr(sel.image) + '" alt="">'
            : '<span class="et-step-builder__slot-img"></span>';
          var meta = sel.variantTitle && sel.variantTitle !== 'Default Title'
            ? '<span class="et-step-builder__slot-variant">' + esc(sel.variantTitle) + '</span>'
            : '';
          filledEl.innerHTML = img + meta;
          filledEl.hidden = false;
        }
        if (removeEl) { removeEl.hidden = false; }
      } else {
        slotEl.classList.add('et-step-builder__slot--empty');
        slotEl.classList.remove('et-step-builder__slot--filled');
        if (emptyEl) { emptyEl.hidden = false; }
        if (filledEl) { filledEl.hidden = true; filledEl.innerHTML = ''; }
        if (removeEl) { removeEl.hidden = true; }
      }
    }

    // ---------- Totals ----------
    function computeTotals() {
      var subtotal = 0;     // sum of current (sale) prices
      var beforeTotal = 0;  // sum of original prices (compare-at when higher than price)
      selection.forEach(function (sel) {
        if (sel) {
          var price = Number(sel.price) || 0;
          var cmp = Number(sel.compareAt) || 0;
          subtotal += price;
          beforeTotal += (discountRef === 'compare' && cmp > price) ? cmp : price;
        }
      });
      var shown = discountPct > 0 ? subtotal - Math.round(subtotal * discountPct / 100) : subtotal;
      var savings = beforeTotal - shown;
      var savingsPct = beforeTotal > 0 ? Math.round(savings / beforeTotal * 100) : 0;
      return { subtotal: subtotal, before: beforeTotal, shown: shown, savings: savings, savingsPct: savingsPct };
    }

    function remainingCount() {
      return selection.filter(function (s) { return !s; }).length;
    }

    function allComplete() {
      return remainingCount() === 0;
    }

    // ---------- UI sync ----------
    function updateSavingsText() {
      if (!savingsEl) { return; }
      var t = computeTotals();
      var remaining = remainingCount();
      if (remaining > 0 && config.savingsTemplate) {
        savingsEl.textContent = fillTokens(config.savingsTemplate, {
          '[count]': remaining,
          '[amount]': formatMoney(t.savings)
        });
        savingsEl.hidden = false;
      } else {
        savingsEl.hidden = true;
      }
    }

    function updateAtc() {
      if (!atcBtn) { return; }
      var t = computeTotals();
      if (allComplete()) {
        atcBtn.disabled = false;
        atcBtn.textContent = (labels.atc || '') + ' · ' + formatMoney(t.shown);
      } else {
        atcBtn.disabled = true;
        atcBtn.textContent = labels.atc || '';
      }
    }

    function updateTabsState() {
      tabEls.forEach(function (tab, i) {
        tab.classList.toggle('et-step-builder__tab--active', i === activeTab);
        tab.classList.toggle('et-step-builder__tab--complete', !!selection[i]);
        tab.setAttribute('aria-selected', i === activeTab ? 'true' : 'false');
      });
      panelEls.forEach(function (panel, i) { panel.hidden = i !== activeTab; });
      updatePanelSub();
      updateFooter();
    }

    function updatePanelSub() {
      var panel = panelEls[activeTab];
      if (!panel) { return; }
      var subEl = panel.querySelector('[data-panel-sub]');
      if (!subEl) { return; }
      var t = computeTotals();
      var remaining = remainingCount();
      if (remaining > 0 && config.savingsTemplate) {
        subEl.textContent = fillTokens(config.savingsTemplate, {
          '[count]': remaining,
          '[amount]': formatMoney(t.savings)
        });
        subEl.hidden = false;
      } else {
        subEl.hidden = true;
      }
      // Reflect current selection state on cards within the active panel.
      var selectedId = selection[activeTab] ? selection[activeTab].productId : null;
      Array.prototype.slice.call(panel.querySelectorAll('[data-card]')).forEach(function (card) {
        card.classList.toggle('et-step-builder__card--selected', String(card.getAttribute('data-product-id')) === String(selectedId));
      });
    }

    function updateFooter() {
      var t = computeTotals();
      if (totalEl) {
        totalEl.textContent = formatMoney(t.shown);
      }
      if (beforeEl) {
        if (t.before > t.shown) { beforeEl.textContent = formatMoney(t.before); beforeEl.hidden = false; }
        else { beforeEl.hidden = true; }
      }
      if (savingsPctEl) {
        if (t.savingsPct > 0) { savingsPctEl.textContent = '-' + t.savingsPct + '%'; savingsPctEl.hidden = false; }
        else { savingsPctEl.hidden = true; }
      }
      if (progressEl) {
        var totalSteps = steps.length;
        var done = totalSteps - remainingCount();
        var pct = totalSteps ? Math.round((done / totalSteps) * 100) : 0;
        progressEl.style.width = pct + '%';
      }
      if (doneBtn) {
        doneBtn.disabled = !allComplete();
        doneBtn.textContent = allComplete() ? (labels.done || '') : (labels.close || '');
      }
    }

    function refreshAll() {
      steps.forEach(function (_, i) { renderSlot(i); });
      updateSavingsText();
      updateAtc();
      updateTabsState();
    }

    // ---------- Tabs ----------
    function switchTab(i) {
      if (i < 0 || i >= steps.length) { return; }
      activeTab = i;
      updateTabsState();
    }

    function firstIncomplete() {
      for (var i = 0; i < selection.length; i++) {
        if (!selection[i]) { return i; }
      }
      return -1;
    }

    function autoAdvance() {
      var next = firstIncomplete();
      if (next === -1) { return; } // all complete — stay (allow done/close)
      switchTab(next);
    }

    // ---------- Card variant live price ----------
    function selectedOption(selectEl) {
      return selectEl.options[selectEl.selectedIndex] || null;
    }

    function updateCardPrice(card) {
      var selectEl = card.querySelector('[data-variant]');
      var opt = selectEl ? selectedOption(selectEl) : null;
      if (!opt) { return; }
      var price = Number(opt.getAttribute('data-price')) || 0;
      var compare = Number(opt.getAttribute('data-compare')) || 0;
      var priceEl = card.querySelector('[data-card-price]');
      var compareEl = card.querySelector('[data-card-compare]');
      var addBtn = card.querySelector('[data-card-add]');
      if (priceEl) { priceEl.textContent = formatMoney(price); }
      if (compareEl) {
        if (compare > price) { compareEl.textContent = formatMoney(compare); compareEl.hidden = false; }
        else { compareEl.hidden = true; }
      }
      if (addBtn) { addBtn.disabled = opt.disabled; }
    }

    // ---------- Record a selection from a card ----------
    function chooseFromCard(card) {
      var stepIndex = Number(card.getAttribute('data-step-index'));
      var productId = card.getAttribute('data-product-id');
      var product = stepProduct(stepIndex, productId);
      if (!product) { return; }
      var selectEl = card.querySelector('[data-variant]');
      var opt = selectEl ? selectedOption(selectEl) : null;
      if (!opt) { return; }
      selection[stepIndex] = {
        productId: productId,
        variantId: opt.value,
        variantTitle: opt.getAttribute('data-title') || '',
        price: Number(opt.getAttribute('data-price')) || 0,
        compareAt: Number(opt.getAttribute('data-compare')) || 0,
        image: opt.getAttribute('data-image') || product.featured || ''
      };
      renderSlot(stepIndex);
      updateSavingsText();
      updateAtc();
      updateTabsState();
      autoAdvance();
    }

    // ---------- Remove a selection ----------
    function clearSelection(i) {
      selection[i] = null;
      renderSlot(i);
      updateSavingsText();
      updateAtc();
      updateTabsState();
    }

    // ---------- Modal ----------
    function openModal(focusIndex) {
      if (!modal) { return; }
      var target = (typeof focusIndex === 'number' && focusIndex >= 0) ? focusIndex : firstIncomplete();
      switchTab(target === -1 ? 0 : target);
      document.documentElement.classList.add('et-step-builder-modal-open');
      document.body.style.overflow = 'hidden';
      if (typeof modal.showModal === 'function' && !modal.open) { modal.showModal(); }
      else { modal.setAttribute('open', ''); }
    }

    function closeModal() {
      if (!modal) { return; }
      if (typeof modal.close === 'function' && modal.open) { modal.close(); }
      else { modal.removeAttribute('open'); }
      document.documentElement.classList.remove('et-step-builder-modal-open');
      document.body.style.overflow = '';
    }

    // ---------- Open the theme's cart drawer (immediately, after add) ----------
    function openCartDrawer() {
      var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification-drawer');
      if (drawer) {
        if (typeof drawer.show === 'function') { drawer.show(); return; }
        drawer.setAttribute('open', '');
        return;
      }
      // Fallback: trigger a cart toggle control if no drawer element is present.
      var trigger = document.querySelector('[aria-controls*="cart-drawer"]');
      if (trigger) { trigger.click(); }
    }

    // ---------- Add all to cart (batched, SupaEasy-tagged) ----------
    function addToCart() {
      if (busy || !allComplete()) { return; }

      // Resolve the line-item property key: exactly one leading underscore.
      var rawKey = (config.linePropertyKey || '').replace(/^_+/, '').trim();
      var propName = '_' + rawKey;

      var items = selection.map(function (sel) {
        var props = {};
        props[propName] = 'true';
        return { id: Number(sel.variantId), quantity: 1, properties: props };
      });

      var sectionsToBundle = ['variant-added'];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true, detail: { sections: sectionsToBundle }
      }));

      busy = true;
      atcBtn.setAttribute('aria-busy', 'true');
      atcBtn.disabled = true;

      fetch(Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: items,
          sections: sectionsToBundle.join(','),
          sections_url: Shopify.routes.root + 'variants/' + items[0].id
        })
      })
        .then(function (response) { return response.json().then(function (json) { return { ok: response.ok, json: json }; }); })
        .then(function (res) {
          busy = false;
          atcBtn.removeAttribute('aria-busy');
          atcBtn.disabled = false;
          if (!res.ok) {
            root.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: res.json.description } }));
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            return;
          }
          closeModal();
          var settings = (window.themeVariables && window.themeVariables.settings) || {};
          if (settings.cartType === 'page' || settings.pageType === 'cart') {
            window.location.href = Shopify.routes.root + 'cart';
            return;
          }
          fetch(Shopify.routes.root + 'cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              cart.sections = res.json.sections;
              root.dispatchEvent(new CustomEvent('variant:add', {
                bubbles: true,
                detail: { items: res.json.items || [res.json], cart: cart }
              }));
              document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
                bubbles: true, detail: { baseEvent: 'variant:add', cart: cart }
              }));
              openCartDrawer();
            });
        })
        .catch(function () {
          busy = false;
          atcBtn.removeAttribute('aria-busy');
          atcBtn.disabled = false;
          root.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: 'Network error' } }));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        });
    }

    // ---------- Wire events ----------
    // Slot click -> open modal on that step (or remove via the "x").
    slotEls.forEach(function (slotEl, i) {
      slotEl.addEventListener('click', function (e) {
        var removeBtn = e.target.closest('[data-slot-remove]');
        if (removeBtn) {
          e.preventDefault();
          e.stopPropagation();
          clearSelection(i);
          return;
        }
        openModal(i);
      });
    });

    // Keyboard remove (Enter/Space on the remove affordance).
    root.addEventListener('keydown', function (e) {
      var removeBtn = e.target.closest('[data-slot-remove]');
      if (!removeBtn) { return; }
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        e.stopPropagation();
        var slotEl = removeBtn.closest('[data-slot]');
        if (slotEl) { clearSelection(Number(slotEl.getAttribute('data-step-index'))); }
      }
    });

    // Tab clicks.
    tabEls.forEach(function (tab, i) {
      tab.addEventListener('click', function () { switchTab(i); });
    });

    // Delegated events inside the panels (variant change + add).
    panelEls.forEach(function (panel) {
      panel.addEventListener('change', function (e) {
        var selectEl = e.target.closest('[data-variant]');
        if (!selectEl) { return; }
        var card = selectEl.closest('[data-card]');
        if (card) { updateCardPrice(card); }
      });
      panel.addEventListener('click', function (e) {
        var addBtn = e.target.closest('[data-card-add]');
        if (!addBtn || addBtn.disabled) { return; }
        var card = addBtn.closest('[data-card]');
        if (card) { chooseFromCard(card); }
      });
    });

    if (atcBtn) { atcBtn.addEventListener('click', addToCart); }
    if (doneBtn) { doneBtn.addEventListener('click', closeModal); }

    if (modal) {
      var closeBtn = modal.querySelector('[data-modal-close]');
      if (closeBtn) { closeBtn.addEventListener('click', closeModal); }
      modal.addEventListener('click', function (e) { if (e.target === modal) { closeModal(); } });
      modal.addEventListener('cancel', function (e) { e.preventDefault(); closeModal(); });
      modal.addEventListener('close', function () {
        document.documentElement.classList.remove('et-step-builder-modal-open');
        document.body.style.overflow = '';
      });
    }

    // ---------- Init ----------
    // Prime each card's price/availability from its default selected option.
    Array.prototype.slice.call(root.querySelectorAll('[data-card]')).forEach(function (card) {
      updateCardPrice(card);
    });
    refreshAll();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-step-bundle]').forEach(function (root) {
      if (root.dataset.etStepInit === 'true') { return; }
      root.dataset.etStepInit = 'true';
      StepBuilder(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Re-init only the changed section/block (no widening to siblings/document).
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) { initAll(e.target); });
})();
